module.exports = __webpack_public_path__ + "img/config.8851728a.svg";